import { ImagesSquare, ArrowUpRight } from "@phosphor-icons/react";
import { useTranslation } from "@/contexts/LanguageContext";
import { GALERIA_SOCIAL_URL } from "@/components/GaleriaShareButton";

const COPY = {
  en: {
    title: "Deliver your work to Galería Social",
    body: "Once you complete a project, deliver your finished work to Galería Social: post your photos there yourself to share them, get feedback and get inspired by other photographers.",
    cta: "Go to Galería Social",
  },
  es: {
    title: "Entrega tu trabajo en Galería Social",
    body: "Una vez que completes un proyecto, entrega tu trabajo terminado en Galería Social: publica tú mismo tus fotos allí para compartirlas, recibir comentarios e inspirarte con otros fotógrafos.",
    cta: "Ir a Galería Social",
  },
};

export default function GaleriaDelivery({ projectId }) {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.en;
  return (
    <div
      className="bg-gradient-to-br from-[#F5A524]/10 via-[#0A0A0A] to-[#0A0A0A] border border-[#F5A524]/30 rounded-lg p-4"
      data-testid={`galeria-delivery-${projectId}`}
    >
      <div className="flex items-center gap-2 mb-1.5">
        <ImagesSquare weight="fill" className="w-4 h-4 text-[#F5A524]" />
        <h4 className="text-[#F5A524] text-xs font-semibold uppercase tracking-widest">{c.title}</h4>
      </div>
      <p className="text-[#A1A1AA] text-sm leading-relaxed mb-3">{c.body}</p>
      <a
        href={GALERIA_SOCIAL_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`galeria-delivery-btn-${projectId}`}
        className="inline-flex items-center gap-1.5 bg-[#F5A524] text-[#0A0A0A] hover:bg-[#F5B041] text-sm font-semibold px-4 py-2 rounded-lg transition-colors group"
      >
        {c.cta}
        <ArrowUpRight weight="bold" className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </a>
    </div>
  );
}
